import {DateTime} from "luxon";

export function formatToLocalTime(dateStr) {
    const dt = DateTime.fromFormat(dateStr, "LLL d, yyyy, h:mm:ss a", {zone: "utc"})
    if (!dt.isValid) {
        return "Invalid Date"
    }
    return dt.setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
        .toLocaleString(DateTime.DATETIME_MED)
}